// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
  box-sizing: border-box;
}*/
/*
body {
  font: 16px Arial;
}*/

/*the container must be positioned relative:*/

.autocomplete-of {
  position: absolute;
  display: inline-block;
  border: 1px solid #eaedf1;
  top: 100% !important;
  max-height: 150px !important;
  /*overflow: scroll !important;*/

  overflow-x: hidden;
  overflow-y: auto;

  z-index: 100;
}
/*
.autocomplete {
  max-height: 200px;
  overflow: scroll;
  position: absolute;
  top: 66px;
  background: white;
  width: 99.5%;
  left: 0.25%;
  z-index: 2;
}*/

.autocomplete-of ul li {
  display: block;
  padding: 6px 8px;
}

input {
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
}

input[type="text"] {
  background-color: #f1f1f1;
  width: 100%;

  /**/
  padding-right: 30px !important;
}

input[type="submit"] {
  background-color: DodgerBlue;
  color: #fff;
  cursor: pointer;
}

.autocomplete-items {
  /*position: absolute;*/
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  /*z-index: 99;*/
  /*position the autocomplete items to be the same width as the container:*/
  /*top: 0;
  left: 0;
  right: 0;*/
  list-style-position: inside;
  padding-left: 0;

  /*ddd*/
  /*  max-height: 100px;
  height: unset;*/
  margin-bottom: 0px;
}

.autocomplete-items li {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}

/*when hovering an item:*/

.autocomplete-items li:hover {
  background-color: #e9e9e9;
}

/*when navigating through the items using the arrow keys:*/

.autocomplete-active {
  background-color: DodgerBlue !important;
  color: #ffffff;
}

.form-control-clear {
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
}

.form-control-feedback {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: block;
  width: 34px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  /*pointer-events: none;*/
}

.hideButton {
  display: none;
}

.parent-input {
  position: relative;
}

.suggestion-container {
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Autocomplete/autocompleteGo.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;;;EAGE;;AAEF,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;;EAE/B,kBAAkB;EAClB,gBAAgB;;EAEhB,YAAY;AACd;AACA;;;;;;;;;;EAUE;;AAEF;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;;EAEX,GAAG;EACH,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE;;YAEU;EACV,2BAA2B;EAC3B,eAAe;;EAEf,MAAM;EACN;iBACe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,yBAAyB;;AAEzB;EACE,yBAAyB;AAC3B;;AAEA,0DAA0D;;AAE1D;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* * {\n  box-sizing: border-box;\n}*/\n/*\nbody {\n  font: 16px Arial;\n}*/\n\n/*the container must be positioned relative:*/\n\n.autocomplete-of {\n  position: absolute;\n  display: inline-block;\n  border: 1px solid #eaedf1;\n  top: 100% !important;\n  max-height: 150px !important;\n  /*overflow: scroll !important;*/\n\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  z-index: 100;\n}\n/*\n.autocomplete {\n  max-height: 200px;\n  overflow: scroll;\n  position: absolute;\n  top: 66px;\n  background: white;\n  width: 99.5%;\n  left: 0.25%;\n  z-index: 2;\n}*/\n\n.autocomplete-of ul li {\n  display: block;\n  padding: 6px 8px;\n}\n\ninput {\n  border: 1px solid transparent;\n  background-color: #f1f1f1;\n  padding: 10px;\n  font-size: 16px;\n}\n\ninput[type=\"text\"] {\n  background-color: #f1f1f1;\n  width: 100%;\n\n  /**/\n  padding-right: 30px !important;\n}\n\ninput[type=\"submit\"] {\n  background-color: DodgerBlue;\n  color: #fff;\n  cursor: pointer;\n}\n\n.autocomplete-items {\n  /*position: absolute;*/\n  border: 1px solid #d4d4d4;\n  border-bottom: none;\n  border-top: none;\n  /*z-index: 99;*/\n  /*position the autocomplete items to be the same width as the container:*/\n  /*top: 0;\n  left: 0;\n  right: 0;*/\n  list-style-position: inside;\n  padding-left: 0;\n\n  /*ddd*/\n  /*  max-height: 100px;\n  height: unset;*/\n  margin-bottom: 0px;\n}\n\n.autocomplete-items li {\n  padding: 10px;\n  cursor: pointer;\n  background-color: #fff;\n  border-bottom: 1px solid #d4d4d4;\n}\n\n/*when hovering an item:*/\n\n.autocomplete-items li:hover {\n  background-color: #e9e9e9;\n}\n\n/*when navigating through the items using the arrow keys:*/\n\n.autocomplete-active {\n  background-color: DodgerBlue !important;\n  color: #ffffff;\n}\n\n.form-control-clear {\n  z-index: 10;\n  pointer-events: auto;\n  cursor: pointer;\n}\n\n.form-control-feedback {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  display: block;\n  width: 34px;\n  height: 34px;\n  line-height: 34px;\n  text-align: center;\n  /*pointer-events: none;*/\n}\n\n.hideButton {\n  display: none;\n}\n\n.parent-input {\n  position: relative;\n}\n\n.suggestion-container {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
